export default __webpack_public_path__ + "static/media/black-arrow.8589e564.svg";